import i18next from 'i18next';
import { html } from 'lit-html';

const TemplateEmbedIndicatorsCapacity = () => {
  return html`
    <div
      id="mypSubastasWidgetView"
      class="mypSubastasWidgetView col-sm-12 col-xs-12"
    >
      <div id="spinner10" class="spinner-container">
        <div class="spinner"></div>
      </div>
      <div class="row intexchange">
        <div id="tabwithcontent"></div>

        ${['1', '2', '3', '4'].map((element) => {
          return html` <div
            id="tab-myp-content${element}"
            class="tab-myp-content tab__content"
          ></div>`;
        })}

        <a
          id="calendar-button"
          href="${i18next.t('routes.lng')}/${i18next.t(
            'routes.auctions_calendar'
          )}#fra"
          class="esios-market-prices__btn-info center"
          >${i18next.t('auctions_calendar')}</a
        >
      </div>
      <div class="col-xs-24 col-sm-24 mt-5"></div>
    </div>
  `;
};

export default TemplateEmbedIndicatorsCapacity;
